import { UploadResponse } from '@/types';
import { apiSlice } from './apiSlice';

type UploadPayload = {
  file: File | { url: string };
  kind?: 'image' | 'icon' | string;
};

export const uploadApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadFile: builder.mutation<UploadResponse, UploadPayload>({
      query: ({ file, kind }) => {
        const formData = new FormData();

        if (file instanceof File) {
          formData.append('file', file);
        } else {
          formData.append('url', file.url);
        }

        return {
          url: kind ? `/upload?kind=${kind}` : '/upload',
          method: 'POST',
          body: formData,
        };
      },
    }),
  }),
});

export const { useUploadFileMutation } = uploadApi;
